export default {"src":"/_next/static/media/manufacturing.2a4199f8.svg","height":50,"width":50,"blurWidth":0,"blurHeight":0};